import { render, staticRenderFns } from "./release2.vue?vue&type=template&id=ad1a6880&scoped=true&"
import script from "./release2.vue?vue&type=script&lang=js&"
export * from "./release2.vue?vue&type=script&lang=js&"
import style0 from "./release2.vue?vue&type=style&index=0&id=ad1a6880&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1a6880",
  null
  
)

export default component.exports